"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backendShipping = void 0;
var utils_1 = require("../../utils");
exports.backendShipping = function (axios) {
    return {
        postShippingsCombine: function (postShippingsCombineRequest) {
            return axios.post('/shippings/combine', postShippingsCombineRequest.data);
        },
        putShippingsAssignInvoices: function (putShippingsAssignInvoicesRequest) {
            return axios.put('/shippings/assign-invoices', putShippingsAssignInvoicesRequest.data);
        },
        putShippingsAssignInvoice: function (putShippingsAssignInvoiceRequest) {
            return axios.put('/shippings/assign-invoice', putShippingsAssignInvoiceRequest.data);
        },
        getShippingsOptions: function (getShippingsOptionsRequest) {
            return axios.get('/shippings/options', getShippingsOptionsRequest);
        },
        putShippingsShippingNo: function (putShippingsShippingNoRequest) {
            var url = utils_1.paramPathchange('/shippings/{shippingNo}', putShippingsShippingNoRequest);
            return axios.put(url, putShippingsShippingNoRequest.data);
        },
        putShippingsShippingNoSimple: function (putShippingsShippingNoSimpleRequest) {
            var url = utils_1.paramPathchange('/shippings/{shippingNo}/simple', putShippingsShippingNoSimpleRequest);
            return axios.put(url, putShippingsShippingNoSimpleRequest.data);
        },
        deleteShippingsCombine: function (deleteShippingsCombineRequest) {
            return axios.delete('/shippings/combine', deleteShippingsCombineRequest);
        },
        getShippings: function (request) {
            return axios.get('/shippings', request);
        },
        getShippingsEnums: function () {
            return axios.get('/shippings/enums');
        }
    };
};
